var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    viewBox: "0 0 21.388 21.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "off",
    transform: "translate(-3248.054 -12184.337)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    cx: 10,
    cy: 10,
    rx: 10,
    ry: 10,
    transform: "translate(3248.335 12184.5)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_357",
    "data-name": "Ellipse 357",
    cx: 10,
    cy: 10,
    rx: 10,
    ry: 10,
    transform: "translate(3248.335 12184.5)",
    fill: "#b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-clockify",
    "data-name": "Icon simple-clockify",
    d: "M9.4,10.588l3.655,3.706,1.047-1.06L10.443,9.528,9.4,10.588Zm4.718-7.616L13.069,1.911,9.414,5.618l1.047,1.06Zm-6.16-.554a5.458,5.458,0,0,1,2.082.413L11.822,1.02A7.826,7.826,0,0,0,7.955,0,8.011,8.011,0,0,0,0,8.067a8.011,8.011,0,0,0,7.955,8.066,7.827,7.827,0,0,0,3.834-1l-1.755-1.781a5.463,5.463,0,0,1-2.078.412,5.623,5.623,0,0,1-5.57-5.673A5.623,5.623,0,0,1,7.955,2.418Z",
    transform: "translate(3258.035 12205.726) rotate(-135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2391",
    "data-name": "Path 2391",
    transform: "matrix(-0.695, -0.719, 0.719, -0.695, 3255.312, 12192.19)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1H4V0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -3.589859034036635e-06 1.000059247016907 L 1.641014023334719e-05 6.920627492945641e-05 L 3.999976396560669 -7.937240411592938e-07 L 3.999956369400024 0.9999892115592957 L -3.589859034036635e-06 1.000059247016907 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.c32f6051.svg";
export { ForwardRef as ReactComponent };